import { useEffect } from "react";
import { ArrowLeft } from "lucide-react";
import { Link } from "react-router-dom";

import { AlluLogo } from "@/components/parceiros/AlluLogo";
import { EventoHeroForm } from "@/components/evento/EventoHeroForm";
import { useMetaPixel } from "@/hooks/useMetaPixel";

const PAGE_TITLE = "Candidatura · Programa de Parceiros Allu";
const PAGE_DESC =
  "Candidatura ao programa de parceiros da Allu Invest. Aplicação revisada manualmente, caso a caso.";

const EventoAplicar = () => {
  useMetaPixel();

  useEffect(() => {
    const prevTitle = document.title;
    document.title = PAGE_TITLE;

    const metaDesc = document.querySelector('meta[name="description"]');
    const prevDesc = metaDesc?.getAttribute("content") ?? "";
    metaDesc?.setAttribute("content", PAGE_DESC);

    const prevBodyBg = document.body.style.backgroundColor;
    const prevBodyColor = document.body.style.color;
    const prevBodyFont = document.body.style.fontFamily;
    document.body.style.backgroundColor = "#0B1A0B";
    document.body.style.color = "#FFFFFF";
    document.body.style.fontFamily =
      '"Plus Jakarta Sans", Inter, system-ui, -apple-system, sans-serif';

    return () => {
      document.title = prevTitle;
      metaDesc?.setAttribute("content", prevDesc);
      document.body.style.backgroundColor = prevBodyBg;
      document.body.style.color = prevBodyColor;
      document.body.style.fontFamily = prevBodyFont;
    };
  }, []);

  return (
    <div
      className="min-h-screen bg-[#0B1A0B] text-white flex flex-col"
      style={{
        fontFamily:
          '"Plus Jakarta Sans", Inter, system-ui, -apple-system, sans-serif',
      }}
    >
      <header className="border-b border-white/10">
        <div className="container-wide py-4 sm:py-5 flex items-center justify-between gap-3">
          <Link to="/evento" aria-label="Voltar para Evento" className="block shrink-0">
            <AlluLogo variant="light" className="h-8 sm:h-10 w-auto" />
          </Link>
          <Link
            to="/evento"
            className="inline-flex items-center gap-1.5 text-sm text-zinc-400 hover:text-white transition-colors"
          >
            <ArrowLeft className="w-4 h-4" />
            Voltar
          </Link>
        </div>
      </header>

      <main className="flex-1">
        <div className="container-narrow py-10 sm:py-16">
          <div className="max-w-xl mx-auto">
            <div className="text-center mb-8 sm:mb-10">
              <div className="text-[11px] font-semibold tracking-[0.14em] uppercase text-zinc-400">
                Aplicação para o programa de parceiros
              </div>
              <h1
                className="mt-3 text-3xl sm:text-4xl md:text-[2.75rem] font-medium text-white leading-[1.1]"
                style={{
                  fontFamily:
                    '"Playfair Display", Georgia, "Times New Roman", serif',
                  letterSpacing: "-0.02em",
                }}
              >
                Quero me candidatar.
              </h1>
              <p className="mt-4 text-base sm:text-lg text-zinc-300 leading-relaxed">
                Aplicação revisada manualmente. Se aprovado, você receberá
                contato no telefone cadastrado.
              </p>
            </div>

            <EventoHeroForm />
          </div>
        </div>
      </main>

      <footer className="border-t border-white/10 mt-10">
        <div className="container-wide py-5 text-center text-[11px] text-zinc-500">
          © {new Date().getFullYear()} Allu · Programa de parceiros Allu Invest
        </div>
      </footer>
    </div>
  );
};

export default EventoAplicar;
